// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Y4BC","rightAdornment":"Header_rightAdornment__lC6Qs"};